import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useI18n } from 'contexts/i18n'
import Modal from 'modals/dialog'
import Paragraph from 'components/typography/paragraph'
import Actions from 'components/form/actions'
import { Plain, Button } from 'components/button'

const GroupInvalidWarning = ({ group, onDone }) => {
    const { formatMessage } = useIntl()
    const { territories } = useI18n()

    return (
        <>
            <Modal.Header
                heading={formatMessage({
                    id: 'organization_number_error_invalid',
                    defaultMessage: 'Invalid organization number'
                })}
                showDismiss={false} />
            <Modal.Body>
                <Paragraph>
                    <FormattedMessage
                        id="group_organization_number_error_invalid_information"
                        defaultMessage="The organization number you entered is not valid in {country}. You can leave it as-is, but some features may not work as expected, such as when integrating with other systems."
                        values={{ country: territories[group.address.country] }} />
                </Paragraph>
            </Modal.Body>
            <Modal.Footer>
                <Actions>
                    <Plain
                        onClick={() => onDone(false)}
                        className="neutral">
                        <FormattedMessage
                            id="action_later"
                            defaultMessage="Later" />
                    </Plain>
                    <Button
                        onClick={() => onDone(true)}
                        className="constructive">
                        <FormattedMessage
                            id="action_keep_editing"
                            defaultMessage="Keep editing" />
                    </Button>
                </Actions>
            </Modal.Footer>
        </>
    )
}

export default GroupInvalidWarning